import type { FC } from "react";

import type { TFormProps } from "@/ui/components/form/Form/Form.config";

export const Form: FC<TFormProps> = (
  {
    children,
    ...props
  },
) => (
  <form
    {...props}
    data-component="Form"
  >
    { children }
  </form>
);

Form.displayName = "Form";
